// Lets other parts of the app open the support chat widget - e.g. the sidebar
// "Share Feedback" link. Module-level registry, like use-support-unread's
// subscriber set: no store, no context, just a hook the mounted widget joins.

type Opener = () => void;

const openers = new Set<Opener>();

/** The widget registers its opener on mount and drops it on unmount. */
export const registerSupportChatOpener = (open: Opener): (() => void) => {
  openers.add(open);

  return () => {
    openers.delete(open);
  };
};

/** Open the support chat from anywhere. No-op if the widget is not mounted. */
export const openSupportChat = (): void => {
  openers.forEach((open) => open());
};
